import { Injectable,inject } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { AuthFirebaseService } from './auth-firebase.service';
import { tap, map } from 'rxjs/operators';
import { Router,CanActivateFn,ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';
import { Observable, } from 'rxjs';
@Injectable({providedIn: 'root'})
export class AuthGuardService{

  constructor(private authService: AuthFirebaseService,private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      tap(authenticated => {
        const email = this.authService.userEmail;
        if (authenticated === this.authService.AuthStatus.PENDING_REGISTER) {
          this.router.navigate(['auth/register'], {
            queryParams: { email: email }
          });
        }else if (authenticated === this.authService.AuthStatus.PENDING_AUTHORIZATION) {
          this.router.navigate(['auth/confirmAuthorization']);
        }else if (authenticated !== this.authService.AuthStatus.AUTHENTICATED) {
          this.router.navigate(['auth/login']);
        }
      }),
      map(authenticated => authenticated === this.authService.AuthStatus.AUTHENTICATED)
    );
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  return inject(AuthGuardService).canActivate(next, state);
}
